import * as React from 'react'
import { connect } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'
import { checklistUpdateComponent } from '../../../../redux/actions'
import FormComponentBuilder from '../FormComponent/FormComponentBuilder'

export interface ComponentData {
  id: string
  optional: boolean
  type: {
    type: string
    values: string[]
  }
  defaultValue: string
  lastValue: string
}

export interface StateProps {
  componentData: ComponentData
  checklistInstanceId: string
  checkId: string
}

export type UpdateComponentFunction = (
  checklistInstanceId: string,
  componentId: string | undefined,
  value: Array<{ subComponentName: string; value: number }> | string | number | undefined,
  conclude: boolean
) => Promise<any>

export interface DispatchProps {
  updateComponent: UpdateComponentFunction
}

export interface OwnProps {
  collapseHandler?: Function
}

export type RadioComponentProps = StateProps & DispatchProps & OwnProps & WithTranslation

const mapDispatchToProps = (dispatch: Function): DispatchProps => {
  return {
    updateComponent: (checklistInstanceId, componentId, value, conclude) =>
      dispatch(checklistUpdateComponent(checklistInstanceId, componentId, value, conclude)),
  }
}

export class RadioComponent extends React.Component<RadioComponentProps> {
  constructor(props: RadioComponentProps) {
    super(props)
    this.updateComponent = this.updateComponent.bind(this)
    this.manageCollapsable()
  }

  private manageCollapsable() {
    if (
      this.props.componentData.lastValue !== this.props.componentData.defaultValue &&
      this.props.componentData.optional &&
      this.props.collapseHandler
    ) {
      this.props.collapseHandler()
    }
  }

  private updateComponent(event: React.MouseEvent<HTMLButtonElement>, value: string) {
    event.persist()
    this.props.updateComponent(this.props.checklistInstanceId, this.props.componentData.id, value, false)
  }

  public render() {
    return (
      <FormComponentBuilder<string> component={this.props.componentData}>
        {({ className, onBlur, updating, value: currentValue, disabled }) => (
          <div className={`${className} btn-group btn-group`} role="group" aria-label="cl-item-example">
            {this.props.componentData.type.values.map(value => {
              if (value === 'OK') {
                return (
                  <RadioButton
                    key={this.props.componentData.id + value}
                    value={value}
                    currentValue={currentValue}
                    componentId={this.props.componentData.id}
                    disabled={disabled}
                    updating={updating}
                    onUpdate={this.updateComponent}
                    onBlur={onBlur}
                  />
                )
              }
              if (value === 'KO') {
                return (
                  <RadioButton
                    key={this.props.componentData.id + value}
                    value={value}
                    currentValue={currentValue}
                    componentId={this.props.componentData.id}
                    disabled={disabled}
                    updating={updating}
                    onUpdate={this.updateComponent}
                    onBlur={onBlur}
                  />
                )
              }
              return (
                <RadioButton
                  key={this.props.componentData.id + value}
                  value={value}
                  currentValue={currentValue}
                  componentId={this.props.componentData.id}
                  disabled={disabled}
                  updating={updating}
                  onUpdate={this.updateComponent}
                  onBlur={onBlur}
                />
              )
            })}
          </div>
        )}
      </FormComponentBuilder>
    )
  }
}

interface RadioButtonProps {
  value: string
  currentValue: string | undefined
  componentId: string
  disabled: boolean
  updating: boolean
  onUpdate: (event: React.MouseEvent<HTMLButtonElement>, value: string) => void
  onBlur: () => void
}

const RadioButton: React.FC<RadioButtonProps> = ({
  value,
  currentValue,
  componentId,
  disabled,
  updating,
  onUpdate,
  onBlur,
}) => {
  const getButtonClassName = () => {
    const baseClasses = 'btn btn-lg btn-outline-secondary'
    const activeClass = value === currentValue ? 'active' : ''
    const hoverClass = value === 'OK' ? 'hover-success' : value === 'KO' ? 'hover-danger' : 'hover-secondary'

    return `${baseClasses} ${hoverClass} ${activeClass}`
  }

  return (
    <button
      type="button"
      className={getButtonClassName()}
      key={componentId + value}
      onClick={event => {
        onUpdate(event, value)
        onBlur()
      }}
      onBlur={onBlur}
      value={value}
      disabled={updating || disabled}
    >
      {value}
    </button>
  )
}

export default connect(null, mapDispatchToProps)(withTranslation()(RadioComponent))
